// D3 and other js use this value in raw color calculations , so we cant use a css: var(--pr-intent-primary); here
export const primaryColor = '#006699'; // ColorAliases.PT_INTENT_PRIMARY;
export const primaryColorLightest = '#e6f7ff'; // TODO: Have Bradford fix this
